module.exports = __webpack_public_path__ + "static/media/audio.36e42399.mp3";